export const version = "wordlists/5.8.0";
//# sourceMappingURL=_version.js.map